import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  HOST = environment.host + '/portal/api/v1/portal';
  token: any = sessionStorage.getItem('token');
  constructor(private http: HttpClient) {}

  //login
  login(params: object): Observable<any> {
    let url = this.HOST + '/user/login';
    return this.http.post(url, params);
  }

  //获取用户信息
  getUserInfo(): Observable<any> {
    ///api/v1/portal/user/profile
    let url = this.HOST + '/user/profile';
    return this.http.get(url);
  }

  getUploadList(params: any): Observable<any> {
    let url = this.HOST + '/examinations/uploadList';

    return this.http.get(url, { params: params });
  }

  //查询小程序二维码
  getEfilmQrCode(params: any): Observable<any> {
    ///api/v1/portal/examinations/{id}/shareQrCode
    let url = this.HOST + '/examinations/' + params.examinationId + '/shareQrCode';
    return this.http.get(url);
  }

  //查询用户的查询组
  getSearchGroups(params: any): Observable<any> {
    ///api/v1/portal/examinations/criteriaSetting
    let url = this.HOST + '/examinations/criteriaSetting';
    return this.http.get(url, { params: params });
  }

  //获取病例详情
  getCaseDetail(params: any): Observable<any> {
    let url = this.HOST + '/examinations/' + params.id;
    return this.http.get(url);
  }

  //获取upload case detail
  getUploadCaseDetail(params: any): Observable<any> {
    let url = this.HOST + '/examinations/unmask/' + params.id;
    return this.http.get(url);
  }

  //提交诊断信息
  submitDiagnosis(params: any): Observable<any> {
    ////api/v1/portal/examinations/submit
    let url = this.HOST + '/examinations/submit';
    return this.http.put(url, params);
  }

  //保存诊断信息
  saveDiagnosis(params: any): Observable<any> {
    ///api/v1/portal/examinations/stash
    let url = this.HOST + '/examinations/stash';
    let headers: any = new HttpHeaders({
      token: this.token,
    });
    return this.http.put(url, params);
  }

  //审核报告
  auditReport(id: string): Observable<any> {
    ///api/v1/portal/examinations/audit
    let url = this.HOST + '/examinations/audit';
    return this.http.put(url, { id: id });
  }

  //驳回报告
  rejectReport(id: string, reason: string): Observable<any> {
    ///api/v1/portal/examinations/reportBack
    let url = this.HOST + '/examinations/reportBack';
    return this.http.put(url, { id: id, backReason: reason });
  }

  //获取诊断列表
  getDiagnosisList(params: any): Observable<any> {
    ///api/v1/portal/examinations/diagnosisList
    let url = this.HOST + '/examinations/diagnosisList';
    return this.http.get(url, { params: params });
  }

  //查询已锁定的病例
  getLockedDiagnosis(params: any): Observable<any> {
    ///api/v1/portal/examinations/works
    let url = this.HOST + '/examinations/works';
    let headers: any = new HttpHeaders({
      token: this.token,
    });
    return this.http.get(url, { params: params });
  }

  //下载pdf
  downloadReport(id: any): Observable<any> {
    ///api/v1/portal/examinations/{id}/createReport
    let url = this.HOST + '/examinations/' + id + '/createReport';
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadFile(data: any, fileName: string, type: string) {
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  //解锁报告
  unlockReport(id: string): Observable<any> {
    ///api/v1/portal/examinations/{id}/unRob
    let url = this.HOST + '/examinations/' + id + '/unRob';
    return this.http.post(url, {});
  }

  //锁定报告
  lockReport(id: string): Observable<any> {
    ///api/v1/portal/examinations/{id}/rob
    let url = this.HOST + '/examinations/' + id + '/rob';
    return this.http.post(url, {});
  }

  //查询用户表头
  getTabelHeader(name: string): Observable<any> {
    ///api/v1/portal/tableColumnSettings/{tableName}
    let url = this.HOST + '/tableColumnSettings/' + name;
    return this.http.get(url);
  }

  //上传报告截图
  uploadReportImg(params: any): Observable<any> {
    ///api/v1/examinations/uploadReport
    let url = this.HOST + '/examinations/uploadReport';
    let formData = new FormData();
    formData.append('examinationId', params.examinationId);
    formData.append('imageBase64', params.file);
    return this.http.post(url, formData);
  }

  //查询数字胶皮短链信息
  getEFLinkInfo(id: string): Observable<any> {
    ////api/v1/portal/shortLinks/query
    let url = this.HOST + '/shortLinks/query';
    return this.http.get(url, { params: { link: id } });
  }

  //获取数字胶片病例详情
  getEFDetail(id: string): Observable<any> {
    ///api/v1/portal//open/api/v1/getExaminationDetail
    let url = environment.host + environment.openAPI + '/getExaminationDetail';
    return this.http.get(url, { params: { examId: id } });
  }

  //补录case
  replenishCase(params: any): Observable<any> {
    ///api/v1/portal/examinations/supplement
    let url = this.HOST + '/examinations/supplement';
    return this.http.put(url, params);
  }

  //格式化性别
  formatGender(value: any) {
    const isEmpty = value === '' || value == null || value === 0;
    const isMale = value === 1 || value === '1' || value === 'M';
    const isFemale = value === 2 || value === '2' || value === 'F';

    if (isEmpty) {
      return '未知';
    } else if (isMale) {
      return '男';
    } else if (isFemale) {
      return '女';
    } else {
      return value;
    }
  }

  //根据状态返回不同的class
  getStatusClass(value: any) {
    let status = '';
    switch (value) {
      case '已报告':
        status = 'submitted';
        break;
      case '已撤回':
        status = 'submitted';
        break;
      case '已退回':
        status = 'returned';
        break;
      case '已锁定':
        status = 'locked';
        break;
      default:
        status = 'waiting';
        break;
    }
    return status;
  }

  //读取设置的表头
  getTableHeader(type: string) {
    ///api/v1/portal/tableColumnSettings/{tableName}
    let url = this.HOST + '/tableColumnSettings/' + type;
    return this.http.get(url);
  }

  //保存表头
  saveTableHeader(params: any): Observable<any> {
    ///api/v1/portal/tableColumnSettings/{tableName}
    let url = this.HOST + '/tableColumnSettings/' + params.tableName;
    return this.http.post(url, params.data);
  }

  //保存查询组
  saveSearchGroup(params: any): Observable<any> {
    ///api/v1/portal/searchGroups
    let url = this.HOST + '/searchGroups';
    return this.http.post(url, params);
  }

  //新增查询组
  addSearchGroup(params: any): Observable<any> {
    ///api/v1/portal/examinations/criteriaSetting
    let url = this.HOST + '/examinations/criteriaSetting';
    return this.http.post(url, params);
  }

  //删除查询组
  deleteSearchGroup(id: string): Observable<any> {
    ///api/v1/portal/examinations/criteriaSetting/{id}
    let url = this.HOST + '/examinations/criteriaSetting/' + id;
    return this.http.delete(url);
  }

  //获取模板
  getTemplate(params: any): Observable<any> {
    ///api/v1/reportTemplates
    let url = this.HOST + '/reportTemplates';
    return this.http.get(url, { params: params });
  }

  //删除模板
  deleteTemplate(params: any): Observable<any> {
    ///api/v1/reportTemplates/{id}
    let url = this.HOST + '/reportTemplates/' + params.id;
    return this.http.delete(url);
  }

  //增加节点
  addNode(params: any): Observable<any> {
    ///api/v1/portal/reportTemplates
    let url = this.HOST + '/reportTemplates';
    return this.http.post(url, params);
  }

  //召回报告
  recallReport(id: string): Observable<any> {
    ///api/v1/portal/examinations/recall
    let url = this.HOST + '/examinations/recall';
    return this.http.put(url, { id: id });
  }
}
